module.exports = __webpack_public_path__ + "img/Wp_2093.3fe184df.png";